import Query from '../../components/Report';

const query = new Query('discover-stats-lifespan');

export default query;
